import LocalizationsState from '../typings/localization';

declare const Config: AppConfiguration;

declare const webSettings: {
  baseUrl: string;
  localizations: LocalizationsState;
};
export interface AppConfiguration {
  env: string;
  apiUrl: string;
  webUrl: string;
  storybookApi?: string;
  localizations: LocalizationsState;
}

export interface SharePlatformDetail {
  key: number;
  id: string;
  shareUrl: string | null;
  mobileOnly: boolean;
}

export const config: AppConfiguration = {
  env: Config.env,
  apiUrl: `${webSettings.baseUrl}${Config.apiUrl}`,
  webUrl: webSettings.baseUrl,
  storybookApi: Config.storybookApi ? Config.storybookApi : undefined,
  localizations: webSettings.localizations,
};

export interface CookieConfig {
  cookiePolicy: string;
  cookiePolicyExpirationDays: number;
  xsrfRequestToken: string;
}

export const shareConfig: SharePlatformDetail[] = [
  {
    key: 1,
    id: 'facebook',
    shareUrl: 'https://www.facebook.com/sharer/sharer.php?u=',
    mobileOnly: false,
  },
  {
    key: 2,
    id: 'twitter',
    shareUrl: 'https://twitter.com/intent/tweet?url=',
    mobileOnly: false,
  },
  {
    key: 3,
    id: 'whatsapp',
    shareUrl: 'whatsapp://send?text=',
    mobileOnly: true,
  },
  {
    key: 4,
    id: 'copylink',
    shareUrl: null,
    mobileOnly: false,
  },
];

export const cookieConfig: CookieConfig = {
  cookiePolicy: 'c_policy',
  cookiePolicyExpirationDays: 60,
  xsrfRequestToken: 'XSRF-REQUEST-TOKEN',
};
